<template>
    <div class="bottombar">
        <transition name="openTray" v-on:before-enter="onAnimationStart" v-on:after-enter="onAnimationEnd">
            <bottomtray v-if="isBottomTrayVisible" v-on:closeTray="closeTray" :presentation="presentation" :person="person" :user="user" :trayType="trayContent" :chatContacts="chatContacts" :chatList="chatList" :presentationList="presentationList" :isLoading="isLoading" :peopleList="peopleList" :questionList="questionList" :peopleMap="peopleMap"></bottomtray>
            <notestray v-if="trayContent === 'Notes'" v-on:closeTray="closeTray" :currentSlide="currentSlide" :presentation="presentation" :slideList="slideList" :user="user"></notestray>
        </transition>
        <ul class="bottom-menu">
            <li v-on:click="openSessions" :disabled="!isAllowedToListSessions">
                <img v-if="trayContent === 'Sessions'" src="../assets/icons/sessions_selected.svg">
                <img v-else src="../assets/icons/sessions_unselected.svg">
            </li>
            <li v-if="this.presentation" v-on:click="openQuestions">
                <div>
                    <img v-if="trayContent === 'Questions'" src="../assets/icons/questions_selected.svg">
                    <img :class="{ notify: newQuestion }" v-else src="../assets/icons/questions_unselected.svg">
                    <div v-if="newQuestion" class="notification-bubble"></div>
                </div>
            </li>
            <li v-if="this.presentation" v-on:click="openPeople">
                <div>
                    <img v-if="trayContent === 'People'" src="../assets/icons/people_selected.svg">
                    <img :class="{ notify: newPerson }" v-else src="../assets/icons/people_unselected.svg">
                    <div v-if="newPerson" class="notification-bubble"></div>
                </div>
            </li>
            <li v-if="this.presentation" v-on:click="openChat" :class="trayContent === 'Chat' ? 'selected' : ''">
                <img v-if="trayContent === 'Chat'" src="../assets/icons/chat_selected.svg">
                <img v-else src="../assets/icons/chat_unselected.svg">
            </li>
            <li v-if="this.presentation" v-on:click="openNotes">
                <img v-if="trayContent === 'Notes'" src="../assets/icons/notes_selected.svg">
                <img v-else src="../assets/icons/notes_unselected.svg">
            </li>
        </ul>
    </div>
</template>

<script>

const REFRESH_PANEL_TIMEOUT = 15000;
const MAX_REFRESH_TIMES = 12;

import BottomTray from '@/components/BottomTray';
import NotesTray from '@/components/NotesTray';
import {EventBus} from '../router/index';

export default {
    components: {
        bottomtray: BottomTray,
        notestray: NotesTray
    },

    props: {
        presentation: {},
        presentationList: {},
        questionList: {},
        peopleList: {},
        peopleMap: {},
        slideList: {},
        user: {},
        currentSlide: '',
        chatList: {},
        chatContacts: {},
        isAllowedToListSessions: Boolean,
        isLoading: Boolean
    },

    data () {
        return {
            trayContent: undefined,
            broadcaster: {},
            contactId: {},
            person: undefined,
            newQuestion: false,
            newPerson: false,
            timerRefresh: undefined,
            refreshTime: 0,
            shouldOpenSessions: false
        };
    },

    computed: {
        isBottomTrayVisible() {
            return this.trayContent !== undefined && this.trayContent !== 'Notes';
        }
    },

    watch: {
        user() {
            if (this.shouldOpenSessions) {
                setTimeout(() => {
                    this.openSessions();
                }, 100);
                this.shouldOpenSessions = false;
            }
        },

        isAllowedToListSessions() {
            if (this.isAllowedToListSessions && this.trayContent === undefined) {
                setTimeout(() => {
                    this.openSessions();
                }, 100);
            }
        },

        presentation() {
            if (this.presentation) {
                this.closeTray();
            }
        },

        peopleList() {
            if (this.trayContent !== 'People') {
                this.newPerson = true;
            }
        }
    },

    mounted() {
        if (this.$route.query.handle) {
            if (this.user.id) {
                setTimeout(() => {
                    this.openSessions();
                }, 100);
            } else {
                this.shouldOpenSessions = true;
            }
        }

        EventBus.$on('openChat', (person) => {
            this.contactId = person.id;
            this.person = person;            
            this.trayContent = 'Chat';

            if (person && person.id) {
                EventBus.$emit("getMessages", person.id);
            }
        });

        EventBus.$on('openPeople', () => {
            this.openPeople();
        });

        EventBus.$on('openPresentation', (presentation) => {
            this.trayContent = undefined;
        });

        EventBus.$on('questionsChanged', () => {
            if (this.trayContent !== 'Questions') {
                this.newQuestion = true;
            }
        });
    },

    methods: {
        onAnimationStart() {
            document.body.style.overflowY = 'hidden';
        },

        onAnimationEnd() {
            document.body.style.overflowY = 'default';
        },

        clearRefreshTimer() {
            if (this.timerRefresh) {
                clearTimeout(this.timerRefresh);
                this.timerRefresh = undefined;
            }
        },

        refreshPanelContent(eventName, eventData) {
            if (++this.refreshTime >= MAX_REFRESH_TIMES) {
                // Show banner
                EventBus.$emit('showBanner', this.$t('str.AutoRefreshDisabledToConserveResourcesClickHereToResume'), () => {
                    this.refreshTime = 0;
                    this.refreshPanelContent(eventName, eventData);
                });
                return;
            }

            this.$emit(eventName, eventData, () => {
                // Schedule a new refresh on whatever is up
                this.timerRefresh = setTimeout(() => {
                    this.timerRefresh = undefined;
                    this.refreshPanelContent(eventName, eventData);
                }, REFRESH_PANEL_TIMEOUT);
            });
        },

        openSessions () {
            this.clearRefreshTimer();
            EventBus.$emit("closeModals"); // Hacky but css change would be too much

            if (!this.isAllowedToListSessions) {
                return;
            }

            if (this.trayContent === 'Sessions' && this.presentation) {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'Sessions';

                if (this.presentation && this.presentation.props) {
                    this.refreshPanelContent('getPresentations', this.presentation.props.PublishedInHandle);
                } else {
                    this.refreshPanelContent('getPresentations', this.$route.query.handle);
                }
            }
        },

        openQuestions () {
            this.clearRefreshTimer();
            EventBus.$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'Questions') {
                this.trayContent = undefined;
            } else {
                this.$set(this, 'trayContent', 'Questions');
                this.newQuestion = false;
                EventBus.$emit('getQuestions', this.presentation.id);
                EventBus.$emit('getPeople', this.presentation.id); 
            }
        },

        openPeople () {
            this.clearRefreshTimer();
            EventBus.$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'People') {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'People';
                this.newPerson = false;
                EventBus.$emit('getPeople', this.presentation.id);
            }      
        },

        openNotes () {
            this.clearRefreshTimer();
            EventBus.$emit("closeModals"); // Hacky but css change would be too much

            if (!this.presentation) {
                return;
            }

            if (this.trayContent === 'Notes') {
                this.trayContent = undefined;
                EventBus.$emit('enableResourcePane');
            } else {
                this.trayContent = 'Notes';
                EventBus.$emit('getSlides', this.presentation.id);
                EventBus.$emit('disableResourcePane');
            }
        },

        openChat() {
            this.clearRefreshTimer();
            EventBus.$emit("closeModals"); // Hacky but css change would be too much

            if (this.trayContent === 'Chat') {
                this.trayContent = undefined;
            } else {
                this.trayContent = 'Chat';
            }
        },

        closeTray() {
            this.trayContent = undefined;
        }
    }
};

</script>

<style lang="scss">

.bottombar {
    .openTray-enter-active {
        animation: slide-in .5s;
    }

    .openTray-leave-active {
        animation: slide-in .5s reverse;
    }

    @keyframes slide-in {
        0% {
            transform: translateY(calc(100vh - 56px));
        }
        100% {
            transform: translateY(0vh);
        }
    }

    .bottom-menu {
        background-color: #000000;
        display: flex;
        flex-direction: row;
        max-width: 100%;
        width: 100%;
        height: 56px;
        flex-flow: row wrap;
        justify-content: center;
        margin: 0;
        position: fixed;
        bottom: 0px;
        left: 0;
        z-index: 5000;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        list-style-type: none;
        padding: 0;

        li {
            cursor: pointer;
            -webkit-box-flex: 1;
            flex-grow: 1;
            display: block;
            float: left;
            text-align: center;
            line-height: 48px;
            padding: 5px 0;
            margin: 0;
            text-transform: uppercase;
            text-overflow: ellipsis;
            overflow: hidden;
            letter-spacing: .8px;
            width: 15%;
            height: 56px !important;
            background-color: #000000;
            border-radius: 2px;
            font-size: 3em;
            align-content: center;
            justify-content: center;
            transition: all .5s;
            list-style-type: none;
            box-sizing: border-box;

            & > div {
                margin: 0 auto;
                display: inline-block;
                position: relative;
            }

            img {
                width: 40px;
                height: 40px;
                border-style: none;
                box-sizing: inherit;
                font-weight: normal;
            }

            a:hover {
                background-color:rgba(75, 76, 79, 0.5);
            }

            .notify {
                margin-left: 15px;
            }
               
            .notification-bubble {
                position: absolute;
                top: 2px;
                right: 0;
                background-color: #d5441d;
                width: 10px;
                height: 10px;
                border-radius: 50%;
            }
        }

        li[disabled="disabled"] {
            cursor: inherit;
            opacity: 0.4;
        }
    }
}

</style>



// WEBPACK FOOTER //
// BottomBar.vue?b0509a76